<template>
  <div class="warehouse-location">
    <div class="warehouse-location-left">
      <div 
        class="warehouse-row"
        :class="{'is-active': activeIndex === index}"
        v-for="(item, index) in warehouseLocationList"
        :key="index"
        @click="selectWarehouse(item, index)"
      >
        <div class="warehouse-row-title">
          <img class="warehouse-img" src="../../../../../assets/images/warehouse/warehouse.png">
          <span class="warehouse-name" :title="item.name">{{ item.name }}</span>
          <span class="warehouse-location-nums" :title="`总库位数：${item.warehouseLocationNums}`">（总库位数：{{ item.warehouseLocationNums }}）</span>
        </div>
        <div class="nums-info">
          <div class="goods-shelves">
            <p class="goods-shelves-nums">{{ item.goodsShelves }}</p>
            <p class="goods-shelves-title">货架数量（个）</p>
          </div>
          <div class="goods-shelves">
            <p class="goods-shelves-nums">{{ item.heaps }}</p>
            <p class="goods-shelves-title">地堆数量（个）</p>
          </div>
        </div>
      </div>
    </div>
    <div class="warehouse-location-right">
      <div class="warehouse-location-right-top">
        <p class="warehouse-location-right-top-title">库位信息</p>
        <div class="btn-container">
          <div class="add-warehouse" @click="addWarehouseLocation">
            <span class="add-warehouse-img"></span>
            <span>添加库位</span>
          </div>
          <div class="upload-warehouse" @click="uploadExcel">
            <span class="upload-warehouse-img"></span>
            <span>库位导入</span>
          </div>
        </div>
      </div>
      <div class="warehouse-location-right-container">
        <div class="table" v-if="tableData.length">
          <el-table :data="tableData" style="width: 100%" :header-cell-class-name="headerCellClassName">
            <el-table-column
              v-for="(item, index) in tableTitleList"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              show-overflow-tooltip
              :min-width="item.width"
              :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
            ></el-table-column>
            <el-table-column
              label="操作"
              width="120"
            >
              <template slot-scope="scope">
                <el-button
                  class="btn-text"
                  type="text"
                  @click="delWarehouseLocation(scope.row.id)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <pagination-tpl
              :total="total"
              :currentPage="currentPage"
              :pageSize="pageSize"
              @queryChange="queryChange"
            ></pagination-tpl>
          </div>
        </div>
        <div v-else class="nothing">
          <img class="nothing-img" src="../../../../../assets/images/nothing//warehous-nothing.png">
        </div>
      </div>
    </div>
    
    <!-- 库位导入 -->
    <el-drawer
      class="export-warehouse-location"
      title="库位导入"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer">
      <div class="el-drawer__body">
        <el-form ref="form" :model="form">
          <div class="tips">
            <img class="sign-blue" src="../../../../../assets/images/sigh/sigh-blue.png">
            <span class="tips-content">导入仓库库位信息</span>
            <span class="tips-text">（功能介绍）</span>
          </div>
          <el-form-item label="仓库名称" prop="warehouseName">
            <el-input v-model="form.warehouseName" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item label="下载导入模板">
            <div class="download-tmp" @click="downloadTmp">
              仓库库位导入模板.xlsx
              <img class="upload-bottom" src="../../../../../assets/images/upload/upload-bottom.png">
            </div>
          </el-form-item>
          <el-form-item label="仓库库位导入">
            <el-input v-if="!uploadFileName" v-model="uploadFileName" placeholder="请上传文件" disabled>
              <template slot="suffix">
                <el-upload
                  v-loading.fullscreen.lock="loading"
                  element-loading-text="文件上传中"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  class="upload"
                  ref="upload"
                  action="#"
                  :show-file-list="false"
                  :auto-upload="true"
                  :before-upload="uploadWarehouseLocationExcel"
                >
                  <img class="upload-img" src="../../../../../assets/images/home/upload.png">
                </el-upload>
              </template>
            </el-input>
            <div v-else class="show-name">
              <span>{{ uploadFileName }}</span>
              <img @click="clearUploadFileName" src="../../../../../assets/images/close.png">
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="confirm">确定</el-button>
      </div>
    </el-drawer>

    <!-- 添加库位库区 -->
    <el-drawer
      class="add-warehouse-location"
      title="添加库位库区"
      :visible.sync="addWarehouseLocationDrawer"
      :wrapperClosable="false"
      :before-close="handleCloseAddWarehouseLocationDrawer">
      <div class="el-drawer__body">
        <el-form ref="addWarehouseLocationForm" :model="addWarehouseLocationForm" :rules="rules">
          <el-form-item label="仓库名称" prop="warehouseName">
            <el-input v-model="addWarehouseLocationForm.warehouseName" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item label="库位编码" prop="code">
            <el-input v-model="addWarehouseLocationForm.code" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="库位类型" prop="type">
            <el-select v-model="addWarehouseLocationForm.type" placeholder="请选择">
              <el-option
                v-for="item in WAREHOUSE_LOCATION_TYPE_LSIT"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用方式" prop="useMethod">
            <el-select v-model="addWarehouseLocationForm.useMethod" placeholder="请选择">
              <el-option
                v-for="item in USE_METHODS_LIST"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="长（m）" prop="long">
            <el-input v-model="addWarehouseLocationForm.long" @input="inputLongTwoNum(addWarehouseLocationForm.long)" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="宽（m）" prop="wide">
            <el-input v-model="addWarehouseLocationForm.wide" @input="inputWideTwoNum(addWarehouseLocationForm.wide)" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="高（m）" prop="hign">
            <el-input v-model="addWarehouseLocationForm.hign" @input="inputHignTwoNum(addWarehouseLocationForm.hign)" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="体积（m³）" prop="volume">
            <el-input v-model="addWarehouseLocationForm.volume" @input="inputVolumeFourNum(addWarehouseLocationForm.volume)" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseAddWarehouseLocationDrawer">取消</el-button>
        <el-button class="btn-blue" @click="confirmAddWarehouseLocation('addWarehouseLocationForm')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import warehouseMixins from '@/common/mixins/warehouse.js'
import statusMixins from '@/common/mixins/status.js'
import WarehouseLocation from '@/models/warehouse-location.js'
import PaginationTpl from "components/base/PaginationTpl";
import { downLoadFile, getDecimal, getFourDecimal } from "common/js/util";
export default {
  mixins: [warehouseMixins, statusMixins],
  components: {
    PaginationTpl,
  },
  data() {
    return {
      // 仓库id
      warehouseLocationId: null,
      activeIndex: 0,
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '仓库', prop: 'warehouseName', width: '', alignment:'left'},
        {label: '库位编码', prop: 'code', width: '', alignment:'left'},
        {label: '库位类型', prop: 'typeVal', width: '', alignment:'left'},
        {label: '使用方式', prop: 'useMethodVal', width: '', alignment:'left'},
        {label: '长(m)', prop: 'long', width: '', alignment:'right'},
        {label: '宽(m)', prop: 'wide', width: '', alignment:'right'},
        {label: '高(m)', prop: 'hign', width: '', alignment:'right'},
        {label: '体积(m³)', prop: 'volume', width: '', alignment:'right'}
      ],

      drawer: false,
      formData: null,
      uploadFileName: '',
      loading: false,
      form: {
        warehouseName: null,
      },

      addWarehouseLocationDrawer: false,
      addWarehouseLocationForm: {
        warehouseName: null,
        code: '',
        type: null,
        useMethod: null,
        long: null,
        wide: null,
        hign: null,
        volume: null,
      },
      rules: {
        code: [
          { required: true, message: '请输入库位编码', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择库位类型', trigger: 'change' },
        ],
        useMethod: [
          { required: true, message: '请选择使用方式', trigger: 'change' },
        ],
      }
    }
  },

  async created() {
    await this.initWarehouseLocation()
    // 默认选择第一个仓库
    this.selectWarehouse(this.warehouseLocationList[0], 0)
  },

  methods: {
    /**
     * @desc 库位列表
     */
    initWarehouseLocationList() {
      let warehouseId = this.warehouseLocationId
      let currentPage = this.currentPage
      let data = {
        warehouseId,
        currentPage
      }
      WarehouseLocation.getWarehouseLocationList(data).then(res => {
        if (res.success) {
          let { totalNum, pageSize, items } = res.result
          this.total = totalNum
          this.pageSize = pageSize
          let arr = []
          items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.warehouseName = i.warehouseName
            obj.code = i.code
            obj.type = i.type
            obj.typeVal = this.WAREHOUSE_LOCATION_TYPE[i.type]
            obj.useMethod = i.method
            obj.useMethodVal = this.USE_METHODS[i.method]
            obj.long = i.length
            obj.wide = i.width
            obj.hign = i.height
            obj.volume = i.volume
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /**
     * @desc 选择仓库初始化库位列表
     */
    selectWarehouse(row, index) {
      this.activeIndex = index
      this.form.warehouseName = row.name
      this.addWarehouseLocationForm.warehouseName = row.name
      this.warehouseLocationId = row.id
      this.initWarehouseLocationList()
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex}) {
      if (columnIndex > 3 && columnIndex < 8) {
        return 'right-align'
      }
    },

    /**
     * @desc 删除库位
     */
    delWarehouseLocation(id) {
      this.$confirm("删除后，该库位信息将从列表消失，请确认", "删除", {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          confirmButtonClass: 'btn-red',
          cancelButtonClass: 'btn-gray'
      }).then(() => {
        let data = {
          id
        }
        WarehouseLocation
          .postDelWarehouseLocation(data)
          .then(res => {
            if (res.success) {
              this.initWarehouseLocationList();
              this.handleCloseAddWarehouseLocationDrawer()
            } else {
              this.$message.error(res.message)
            }
          })
      });
    },

    addWarehouseLocation() {
      this.addWarehouseLocationDrawer = true
    },

    uploadExcel() {
      this.drawer = true
    },
    
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initWarehouseLocationList()
    },
    
    handleCloseDrawer() {
      this.formData = null
      this.uploadFileName = ''
      this.drawer = false
    },

    downloadTmp() {
      let url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/%E4%BB%93%E5%BA%93%E5%BA%93%E4%BD%8D%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'
      downLoadFile('仓库库位导入模板',url)
    },

    uploadWarehouseLocationExcel(file) {
      this.loading = true
      var formData = new FormData();
      formData.append("file", file);
      this.formData = formData
      this.uploadFileName = file.name
      if (file) {
        this.loading = false
      }
      return false;
    },

    /**
     * @desc 导入库位
     */
    confirm() {
      let formData = this.formData
      if (formData.get('warehouseId')) {
        formData.delete('warehouseId')
      }
      formData.append("warehouseId", this.warehouseLocationId);
      WarehouseLocation
        .postUploadWarehouseLocationExcel(formData)
        .then(res => {
          if (res.success) {
            this.$message.success("导入成功");
            this.initWarehouseLocationList();
            this.handleCloseDrawer()
          } else {
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning",
              confirmButtonClass: 'btn-blue'
            }).then(() => {});
          }
        })
        .catch(res => {
          this.$message.error("导入失败");
        });
    },

    /**
     * @desc 删除上传文件
     */
    clearUploadFileName() {
      this.uploadFileName = ''
      let formData = this.formData
      if (formData.get('file')) {
        formData.delete('file')
      }
    },

    handleCloseAddWarehouseLocationDrawer() {
      this.$refs['addWarehouseLocationForm'].resetFields();
      this.addWarehouseLocationDrawer = false
    },

    /**
     * @desc 长限制2位小数
     */
    inputLongTwoNum(v) {
      this.addWarehouseLocationForm.long = getDecimal(v);
    },

    inputWideTwoNum(v) {
      this.addWarehouseLocationForm.wide = getDecimal(v);
    },

    inputHignTwoNum(v) {
      this.addWarehouseLocationForm.hign = getDecimal(v);
    },

    /**
     * @desc 体积限制4位小数
     */
    inputVolumeFourNum(v) {
      this.addWarehouseLocationForm.volume = getFourDecimal(v);
    },
    
    /**
     * @desc 保存库位
     */
    confirmAddWarehouseLocation(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.warehouseLocationId
          let code = this.addWarehouseLocationForm.code
          let type = this.addWarehouseLocationForm.type
          let method = this.addWarehouseLocationForm.useMethod
          let length = Number(this.addWarehouseLocationForm.long)
          let width = Number(this.addWarehouseLocationForm.wide)
          let height = Number(this.addWarehouseLocationForm.hign)
          let volume = Number(this.addWarehouseLocationForm.volume)
          let data = {
            warehouseId,
            code,
            type,
            method,
            length,
            width,
            height,
            volume
          }
          WarehouseLocation
            .postAddWarehouseLocation(data)
            .then(res => {
              if (res.success) {
                this.initWarehouseLocationList();
                this.handleCloseAddWarehouseLocationDrawer()
              } else {
                this.$message.error(res.message)
              }
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/warehouse/warehouse-location.scss';
</style>
